<template>
  <v-container fluid class="footer">
    <v-layout row wrap footer-inner>
      <v-flex xs12 class="pa-3">
        <div class="social-icons teal--text text-xs-center">
          <a class="facebook" href="https://www.facebook.com/KidsOutAndAboutRochester/">
            <v-icon>fab fa-facebook</v-icon>
          </a>
          <a class="twitter" href="https://twitter.com/koarochester">
            <v-icon>fab fa-twitter-square</v-icon>
          </a>
          <a class="pinterest" href="https://ro.pinterest.com/KOAARochester/">
            <v-icon>fab fa-pinterest-square</v-icon>
          </a>
          <a class="instagram" href="https://www.instagram.com/rochesterkids/">
            <v-icon>fab fa-instagram</v-icon>
          </a>
        </div>

        <div class="footer-logo mb-3">
          <img class="mx-auto" src="./../assets/ec-logo.svg" />
        </div>

        <div class="text-xs-center main-footer-links">
          <v-btn v-for="link in mainFooterLinks" :key="link.title" color="#6f6f6f" flat round small>
            <a :href="link.href">{{ link.title }}</a>
          </v-btn>
        </div>
      </v-flex>

      <NewsLetter></NewsLetter>

      <v-flex xs12 sm6 class="pa-4 flatblack text-xs-center text-sm-left">
        <div class="white--text">
          &copy;
          <span>Copyright 2018 EntertainmentCalendar.com. All rights reserved.</span>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pa-3 flatblack text-xs-center text-sm-right bottom-links">
        <v-btn v-for="link in bottomLinks" :key="link.title" color="white" flat round small>
          <a :href="link.href">{{ link.title }}</a>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NewsLetter from "./NewsLetter";

export default {
  name: "EtFooter",
  components: {
    NewsLetter
  },
  data() {
    return {
      footerLinks: [
        "How to Advertise Nationally",
        "National Media Kit",
        "Write Submissions",
        "Create a National Account",
        "Log in to your Account",
        "Advertising on a National Level"
      ],
      mainFooterLinks: [
        {
          href: "#",
          title: "How to Advertise Nationally"
        },
        {
          href: "#",
          title: "National Media Kit"
        },
        {
          href:
            "https://rochester.kidsoutandabout.com/content/writer-submissions",
          title: "Write Submissions"
        },
        {
          href: "#",
          title: "Create a National Account"
        },
        {
          href: "https://rochester.kidsoutandabout.com/user",
          title: "Log in to your Account"
        },
        {
          href: "http://www.entertainmentcalendar.com/",
          title: "Advertising on a National Level"
        }
      ],
      bottomLinks: [
        {
          href: "https://rochester.kidsoutandabout.com/content/terms-service",
          title: "Terms of service"
        },
        {
          href: "https://rochester.kidsoutandabout.com/content/privacy-policy",
          title: "Privacy Policy"
        },
        {
          href: "https://rochester.kidsoutandabout.com/content/contact-us",
          title: "Contact us"
        }
      ]
    };
  }
};
</script>
<style>
.container.footer {
	padding: 0;
}

.footer-inner {
  background-color: #fff;
	background-image: linear-gradient(to bottom, rgba(233, 233, 233, 0.8) 10%, #fff 30%);
	border-top: 1px solid #000;
}

.social-icons {
  display: block;
  margin-top: -35px;
  position: relative;
	padding-bottom: 15px;
}

.social-icons i {
  font-size: 20px;
  margin: 0;
  color: #fff !important;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.social-icons a {
	display: inline-block;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	position: relative;
	margin: 0 3px;
}

.social-icons a.facebook {
	background-color: #205b9e;
}

.social-icons a.twitter {
	background-color: #00abe3;
}

.social-icons a.pinterest {
	background-color: #c8232c;
}

.social-icons a.instagram {
	background-color: #2e7fa6;
}

.footer-logo img {
  width: 680px;
  max-width: 100%;
  display: block;
}

.bottom-links a {
  color: #fff;
  text-decoration: none;
	font-weight: normal;
	font-size: 14px;
}

.main-footer-links {
  width: 900px;
  margin: 0 auto;
  max-width: 100%;
}

.main-footer-links a {
  color: #f03c1e;
  font-weight: normal;
  text-decoration: none;
}

.main-footer-links button {
  margin-top: 2px;
  margin-bottom: 2px;
}

.main-footer-links button::after {
  content: '|';
  display: inline-block;
  position: relative;
  left: 18px;
  color: #f03c1e;
}

.main-footer-links button:hover {
  background: #f03c1e;
}

.main-footer-links button:hover a {
  color: #fff;
}

@media screen and (min-width:600px) {
	.social-icons {
		padding-bottom: 30px;
		margin-top: -45px;
	}

	.social-icons a {
		width: 55px;
		height: 55px;
		margin: 0 5px;
	}

	.social-icons i {
		font-size: 30px;
		line-height: 30px;
	}
}
</style>
